export default __webpack_public_path__ + "static/media/Bandeau 27 HD.d88d9ebd.jpg";